import { useMemo } from 'react';
import type { MarketplaceServiceProviderOfferResponse } from '@gcv/shared';
import { GCD_RIVERBANK_BANK_ID, PAYQWICK_BANK_ID } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { DispensariesApi } from 'api';
import { CRB_MARKETPLACE_OFFERS_KEY } from 'tanstack-hooks/keys';

// TODO update this to use the current dispensary from hooks when we make it
export function useDispensaryMarketplaceOffers(dispensaryId: string, isPlantTouching: boolean) {
  const dispensaryApi = new DispensariesApi();

  const {
    data: crbMarketplaceOffersResponse,
    isLoading: isLoadingCrbMarketplaceOffers,
    isError: isCrbMarketplaceOffersError
  } = useQuery<MarketplaceServiceProviderOfferResponse[]>({
    enabled: true,
    queryKey: [CRB_MARKETPLACE_OFFERS_KEY, dispensaryId, isPlantTouching], // todo update to use hooks
    queryFn: () => dispensaryApi.getMarketplaceOffersForDispensary(dispensaryId, isPlantTouching)
  });

  const { crbMarketplaceOffers } = useMemo(() => {
    if (!crbMarketplaceOffersResponse) {
      return { crbMarketplaceOffers: undefined };
    }

    // sort offers alphabetically
    const marketplaceOffers = crbMarketplaceOffersResponse.sort((a, b) => a.title.localeCompare(b.title));
    // find index of Green Check Direct/PayQwick provider id if it exists
    const gcdIndex = marketplaceOffers.findIndex(
      ({ provider_id }) => provider_id === PAYQWICK_BANK_ID || provider_id === GCD_RIVERBANK_BANK_ID
    );
    // move the GCD offer to front of the line if it exists
    if (gcdIndex > -1) {
      // catpture offer at index
      const gcdOffer: MarketplaceServiceProviderOfferResponse = marketplaceOffers[gcdIndex];
      // remove offer at index
      marketplaceOffers.splice(gcdIndex, 1);
      // move captured offer to front of the line
      marketplaceOffers.unshift(gcdOffer);
    }

    return {
      crbMarketplaceOffers: crbMarketplaceOffersResponse
    };
  }, [crbMarketplaceOffersResponse]);

  return {
    crbMarketplaceOffers,
    isLoadingCrbMarketplaceOffers,
    isCrbMarketplaceOffersError
  };
}
